import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useCloudinaryService = () => {
  const { language } = useLanguage();
  const t = messageTranslations[language] || messageTranslations["de"];

  const uploadFormLogo = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/cloudinary/uploadFormLogo`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(t.cloudinary?.uploadError || "Fehler beim Upload.");
      }

      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error("Logo Upload Error:", error.message);
      message.error(t.cloudinary?.uploadError || "Fehler beim Logo Upload.");
      return null;
    }
  };

  const uploadImageDirectly = async (base64Image) => {
    try {
      const formData = new FormData();

      // Convert base64 to blob
      const response = await fetch(base64Image);
      const blob = await response.blob();

      formData.append("file", blob);
      formData.append("upload_preset", "feedback_images"); // Use the preset name you'll create
      formData.append("folder", "feedback-images"); // Optional: organize in folders

      const uploadResponse = await fetch(
        `https://api.cloudinary.com/v1_1/dppvqthzn/image/upload`, // Using your cloud name
        {
          method: "POST",
          body: formData,
        }
      );

      if (!uploadResponse.ok) {
        throw new Error("Upload failed");
      }

      const data = await uploadResponse.json();
      return data.secure_url; // Returns the uploaded image URL
    } catch (error) {
      console.error("Direct Cloudinary upload error:", error);
      message.error(t.cloudinary?.uploadError || "Fehler beim Bilder Upload.");
      return null;
    }
  };

  return {
    uploadFormLogo,
    uploadImageDirectly
  };
};

export default useCloudinaryService;
